export { Component, View } from "./internal.js";